import React from 'react';
import PropTypes from 'prop-types';
import { Anchor, Checkbox, Label, LabeledControl } from '@zillow/constellation';
import { URLS } from '../../../constants/urls';

const RentingPledge = ({ value, onChange }) => {
  return (
    <LabeledControl
      marginBottom="md"
      label={
        <Label data-test="renting-pledge__label">
          {`I agree to follow the community standards put forth within the `}
          <Anchor
            rel="noreferrer"
            href={URLS.GOOD_NEIGHBOR_POLICY}
            target="_blank"
            data-test="renting-pledge__anchor-good-neighbor"
          >
            Good Neighbor Policy
          </Anchor>
          {` and the `}
          <Anchor
            rel="noreferrer"
            href={URLS.RESPECTFUL_RENTING_PLEDGE}
            target="_blank"
            data-test="renting-pledge__anchor-rent-pledge"
          >
            Respectful Renting Pledge
          </Anchor>
          .
        </Label>
      }
      control={<Checkbox checked={value} onChange={onChange} data-test="renting-pledge__checkbox" />}
    />
  );
};

RentingPledge.propTypes = {
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default RentingPledge;
